import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Form, Button, Row, Col, Image, Alert } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';
import config from '../config';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { isMonday, isAfter, isBefore, subDays } from 'date-fns';
const Confirmation = () => {
    const { caseId } = useParams();
    const [renewalCase, setRenewalCase] = useState({});
    const [loading, setLoading] = useState(true);
    const [confirmationDate, setConfirmationDate] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchCase = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/RenewalCases/${caseId}`);
                setRenewalCase(response.data);
                setConfirmationDate(response.data.expectedResponseDate ? new Date(response.data.expectedResponseDate) : null);
            } catch (error) {
                console.error('Error fetching case:', error);
            }finally {
                setLoading(false);
            }
        };
        fetchCase();
    }, [caseId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if(confirmationDate){
            const localDate = new Date(confirmationDate.getFullYear(), confirmationDate.getMonth(), confirmationDate.getDate());
    
        
            const formattedDate = localDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });

            try {
                const patchData = [
                    { op: 'replace', path: '/expectedResponseDate', value: formattedDate }
                ];
    
                await axios.patch(`${config.API_URL}/RenewalCases/${caseId}`, patchData);
                setMessage(
                    <>
                        Expected Submission Date updated successfully to <strong>{formattedDate}</strong>!
                    </>
                );
            } catch (error) {
                console.error('Error updating Expected Submission Date:', error);
                setError('Failed to update Expected Submission Date.');
            }
        }
        
        

        
    };

    const renewalDateObj = new Date(renewalCase?.renewalDate);

    
    const startDate = subDays(renewalDateObj, 60);

   
    const endDate = subDays(renewalDateObj, 15);

    
    const filterDate = (date) => {
        
        if (!isMonday(date)) return false;

        
        return isAfter(date, startDate) && isBefore(date, endDate);
    };

    
   

    

    return (
        <Layout>
            <div className="confirmation-container mt-5">
                <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
                    <div className="text-center mb-4">
                        <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
                    </div>

                    {message && <Alert variant="success" className="text-center">{message}</Alert>}
                    {error && <Alert variant="danger" className="text-center">{error}</Alert>}


                    {loading ? (
                        <div className="text-center">
                            <Skeleton count={5} />
                        </div>
                    ) :renewalCase?.expectedResponseDate ? (
                        <div className="text-center">
                            <Alert variant="info">
                            Expected Submission Date has already been set: <strong>{new Date(renewalCase.expectedResponseDate).toLocaleDateString()}</strong>
                            </Alert>
                        </div>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                        <Row className="mt-3 ">
                            <Col lg={8} >
                                <Form.Group controlId="confirmationDate" className="d-flex align-items-center">
                                    <Form.Label className="confirmation-form-label me-3 mb-0" style={{ whiteSpace: 'nowrap' }}>Expected Submission Date</Form.Label>
                                    <DatePicker
                                        selected={confirmationDate}
                                        onChange={(date) => setConfirmationDate(date)}
                                        filterDate={filterDate}
                                        className="form-control form-control-lg"
                                        placeholderText="Select Date"
                                        required
                                        minDate={startDate}
                                        maxDate={endDate}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    
                        <div className="text-center">
                            <Button variant="primary" type="submit" className="mt-4 btn-lg">
                                Submit
                            </Button>
                        </div>
                    </Form>
                    
                    )}
                </Card>
            </div>
        </Layout>
    );
};

export default Confirmation;
